import { Observable, map } from 'rxjs';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UserInfoState } from 'src/store/reducers/user-info.reducer';
import { inject } from '@angular/core';

export function authGuard(): Observable<boolean> {
    const store = inject<Store<{ userInfo: UserInfoState }>>(Store);
    const router = inject(Router);
    return store
        .select((state) => state.userInfo)
        .pipe(
            map((userInfo) => {
                if (!userInfo) {
                    router.navigate(['/login']);
                    return false;
                }
                return true;
            })
        );
}
